// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DescriptorValue__attributeValue__UGH2W{margin:0.5rem}.DescriptorValue__attributeValue__UGH2W:first-child{margin-top:0}.DescriptorValue__attributeValue__UGH2W:last-child{margin-bottom:0}
`, "",{"version":3,"sources":["webpack://./src/js/apps/common/components/DescriptorValue/DescriptorValue.scss"],"names":[],"mappings":"AAAA,wCACI,aAAc,CADlB,oDAIQ,YAAa,CAJrB,mDAQQ,eAAgB","sourcesContent":[".attributeValue {\n    margin: 0.5rem;\n\n    &:first-child {\n        margin-top: 0;\n    }\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"attributeValue": `DescriptorValue__attributeValue__UGH2W`
};
export default ___CSS_LOADER_EXPORT___;
